import { Link, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/sms-consent')({
  component: SmsConsentPage,
});

const CONTACT_EMAIL = 'support@pirouettehq.com';

function SmsConsentPage() {
  return (
    <main
      id="main"
      className="min-h-dvh bg-[var(--color-surface-sunken)] px-6 py-10 text-[var(--color-ink)] sm:px-10 lg:px-16"
      data-testid="sms-consent-page"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-10">
        <nav aria-label="Public navigation" className="flex items-center justify-between gap-6">
          <Link
            to="/"
            className="font-[var(--font-display)] tracking-[var(--tracking-wide)] text-[var(--text-lg)] uppercase"
          >
            Pirouette
          </Link>
          <div className="flex items-center gap-5 text-[var(--text-sm)]">
            <Link to="/privacy" className="text-[var(--color-ink-muted)] hover:underline">
              Privacy
            </Link>
            <Link to="/terms" className="text-[var(--color-ink-muted)] hover:underline">
              Terms
            </Link>
            <Link to="/contact" className="text-[var(--color-ink-muted)] hover:underline">
              Contact
            </Link>
            <Link to="/signup" className="text-[var(--color-ink-muted)] hover:underline">
              Create account
            </Link>
          </div>
        </nav>

        <section className="max-w-3xl">
          <p className="font-[var(--font-display)] tracking-[var(--tracking-wide)] text-[var(--color-accent)] text-[var(--text-base)] uppercase">
            SMS consent
          </p>
          <h1 className="mt-4 leading-[var(--leading-tight)] font-[var(--font-display)] tracking-[var(--tracking-tight)] text-[var(--text-display)]">
            Pirouette text message alerts
          </h1>
          <p className="mt-6 leading-[var(--leading-relaxed)] text-[var(--color-ink-muted)] text-[var(--text-lg)]">
            Pirouette may send transactional text alerts for enrolled studio families who choose to
            receive them. SMS consent is optional and is not required to create an account, enroll
            in a class, purchase services, or use Pirouette.
          </p>
        </section>

        <section className="grid gap-5 md:grid-cols-2">
          <article className="rounded-[var(--radius-lg)] border border-[var(--color-border)] bg-[var(--color-surface)] p-6">
            <h2 className="font-semibold text-[var(--text-xl)]">Enrollment status</h2>
            <p className="mt-3 leading-[var(--leading-relaxed)] text-[var(--color-ink-muted)]">
              Pirouette no longer publishes a phone number for new SMS enrollment. For current
              enrollment instructions or messaging assistance, email{' '}
              <a href={`mailto:${CONTACT_EMAIL}`} className="text-[var(--color-accent)]">
                {CONTACT_EMAIL}
              </a>
              . Review our{' '}
              <Link to="/privacy" className="text-[var(--color-accent)]">
                Privacy Policy
              </Link>{' '}
              and{' '}
              <Link to="/terms" className="text-[var(--color-accent)]">
                Terms
              </Link>
              .
            </p>
          </article>

          <article className="rounded-[var(--radius-lg)] border border-[var(--color-border)] bg-[var(--color-surface)] p-6">
            <h2 className="font-semibold text-[var(--text-xl)]">How to opt out or get help</h2>
            <p className="mt-3 leading-[var(--leading-relaxed)] text-[var(--color-ink-muted)]">
              Reply <strong>STOP</strong> to unsubscribe at any time. Reply <strong>HELP</strong>{' '}
              for help. You can also contact Pirouette at{' '}
              <a href={`mailto:${CONTACT_EMAIL}`} className="text-[var(--color-accent)]">
                {CONTACT_EMAIL}
              </a>
              .
            </p>
          </article>
        </section>

        <section className="rounded-[var(--radius-lg)] border border-[var(--color-border)] bg-[var(--color-surface)] p-6">
          <h2 className="font-semibold text-[var(--text-xl)]">Program terms</h2>
          <div className="mt-4 grid gap-4 leading-[var(--leading-relaxed)] text-[var(--color-ink-muted)] md:grid-cols-2">
            <p>
              Pirouette SMS alerts are transactional account notifications for dance-studio
              families. They may include time-sensitive class schedule changes and tuition payment
              issue alerts. Pirouette does not use this SMS program for marketing messages.
            </p>
            <p>
              Carriers are not liable for delayed or undelivered messages. Mobile opt-in data and
              consent are not sold, rented, or shared with third parties for their marketing or
              promotional purposes.
            </p>
          </div>
        </section>
      </div>
    </main>
  );
}
